import React from 'react';

const URL_REGEX =
  /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;

export const linkifyText = (text) => {
  if (!text) return text;

  const parts = [];
  let lastIndex = 0;

  for (const match of text.matchAll(URL_REGEX)) {
    const urlText = match[0];
    const index = match.index;

    // text before link
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }

    let href = urlText;
    if (!href.startsWith('http')) {
      href = `http://${href}`;
    }

    parts.push(
      <a
        key={index}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline', color: 'inherit' }}
      >
        {urlText}
      </a>
    );

    lastIndex = index + urlText.length;
  }

  // remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};
